import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import logo from "../assets/logohorizontal.png";
import qrcodeDownload from "../assets/qrcode.png";
import appleDownloadBlack from "../assets/apple-download-black.png";
import googleDownloadBlack from "../assets/google-download-black.png";
import facebookWhite from "../assets/facebook-white.png";
import instagramWhite from "../assets/instagram-white.png";
import whatsappWhite from "../assets/whatsapp-white.png";

const Wrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  backgroundColor: theme.palette.common.black,
  borderTop: "1px solid #e0e0e0",
  color: theme.palette.common.white,

  "& a": {
    color: "inherit",
    textDecoration: "underline",

    "&:hover": {
      color: `${theme.palette.common.white}80`,
    },
  },
}));

const Container = styled(Box)(({ theme }) => ({
  boxSizing: "border-box",
  margin: "auto",
  maxWidth: theme.breakpoints.values.xl,

  padding: theme.spacing(0, 4),
}));

const Content = styled(Box)(({ theme }) => ({
  display: "flex",
  flexFlow: "column nowrap",
  alignItems: "center",
  gap: theme.spacing(4, 4),
  width: "100%",
  padding: theme.spacing(4, 0),

  [theme.breakpoints.up("md")]: {
    flexFlow: "row nowrap",
    ["& > div"]: {
      width: "50%",
    },
  },

  ["& > div"]: {
    width: "100%",
  },
}));

const SocialLink = styled("a")(({ theme }) => ({
  display: "flex",
  flexFlow: "row nowrap",
  gap: theme.spacing(1, 1),
  justifyContent: "flex-start",
  alignItems: "center",
}));

const FooterLinks = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.common.white}`,
  padding: theme.spacing(2, 0),
  display: "flex",
  flexFlow: "row wrap",
  gap: theme.spacing(1, 2),
}));

export default function Footer() {
  return (
    <Wrapper>
      <Container>
        <Content>
          <Stack spacing={2} alignItems="start">
            <img src={logo} alt="Logo Fynd" style={{ maxWidth: "112px" }} />

            <b>Sua plataforma de consultas médicas com vantagens exclusivas!</b>

            <span>Rua Luiz José de Matos, 437 • Ribeirão Preto/SP</span>

            <span>Telefone: (16) 3606-0800</span>

            <SocialLink href="https://wa.me/1636060800" target="_blank">
              <img
                src={whatsappWhite}
                alt="Logo WhatsApp"
                style={{ width: "24px" }}
              />
              <span>Conversar no WhatsApp</span>
            </SocialLink>
          </Stack>

          <Stack spacing={2} alignItems="start">
            <span>
              Baixe o nosso aplicativo <b>Fynd Saúde</b>
            </span>

            <Stack direction="row" spacing={2}>
              <img src={qrcodeDownload} style={{ height: 135 }} />

              <Stack
                justifyContent="space-between"
                alignItems="center"
                sx={{ py: "4px" }}
              >
                <a
                  href="https://play.google.com/store/apps/details?id=br.com.conexo.saude"
                  target="_blank"
                  style={{ display: "inline-block", height: 55 }}
                >
                  <img src={googleDownloadBlack} style={{ height: 55 }} />
                </a>

                <a
                  href="https://apps.apple.com/br/app/conexo-saúde/id1542610505?platform=iphone"
                  target="_blank"
                  style={{ display: "inline-block", height: 55 }}
                >
                  <img src={appleDownloadBlack} style={{ height: 55 }} />
                </a>
              </Stack>
            </Stack>

            <span>Sigam nossas contas nas redes sociais</span>

            <Stack direction="row" spacing={2}>
              <SocialLink
                href="https://www.instagram.com/fynd.saude/"
                target="_blank"
              >
                <img
                  src={instagramWhite}
                  alt="Logo Instagram"
                  style={{ width: "24px" }}
                />
                <span>Instagram</span>
              </SocialLink>

              <SocialLink
                href="https://www.facebook.com/fynd.saude1/"
                target="_blank"
              >
                <img
                  src={facebookWhite}
                  alt="Logo Facebook"
                  style={{ width: "24px" }}
                />
                <span>Facebook</span>
              </SocialLink>
            </Stack>
          </Stack>
        </Content>

        <FooterLinks>
          <span>© Fynd - Todos os direitos reservados</span>
          <span>|</span>
          <span>Código de conduta</span>
          <span>|</span>
          <span>Termos de uso</span>
          <span>|</span>
          <span>Política de privacidade</span>
        </FooterLinks>
      </Container>
    </Wrapper>
  );
}
